import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import card from "../../assets/img/card-vegzelma.png";
import DownloadPDF from "../../utilities/pdfDownloader";
import cardyuflyma from "../../assets/img/card-yuflyma.png";
import bevacizumab from "../../assets/img/Color_bevacizumab_adcdHigh.png";
import cardadalimumab from "../../assets/img/card-adalimumab.png";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import yuflymaLogo from "../../assets/img/yuflyma-logo.png";
import zymfentraLogo from "../../assets/img/Zymfentra_brand.png";
import adalimumabLogo from "../../assets/img/Adalimumab-aaty_logo.png";
import cardzymfentra from "../../assets/img/card-zymfentra-group.png";
import cardsteqeyma from "../../assets/img/card-steqeyma.png";
import cardstoboclo from "../../assets/img/card-stoboclo.png";
import cardosenvelt from "../../assets/img/card-osenvelt.png";
import cardavtozma from "../../assets/img/card-avtozma.png";
import cardomlyclo from "../../assets/img/card-omlyclo.png";

import {
  getProductColor,
  getProductButtonColor,
} from "../../utilities/productColor";

const Pharma = (props) => {
  let cardID = localStorage.getItem("cardID");

  // Figma renders the AM/PM meridiems slightly smaller than the hour.
  const meridiem = { fontSize: "0.8em", textTransform: "uppercase" };

  const [searchParams] = useSearchParams();
  const { category } = useParams();
  const isFirstRender = useRef(false);
  const isZymfentra = category === "zymfentra";
  const location = useLocation();
  const [modalShow, setModalShow] = useState(false);
  const productColor = getProductColor(location.pathname);
  // Figma "1.2.3 Enroll Now Step 4 pdf": heading + claim content sit on a
  // tinted panel, and the page is 612 wide with 566 inner blocks. Scoped to
  // OMLYCLO so the other products' PDF pages are untouched.
  // Products whose member-ID overlay has been re-based on .card-fixed - the
  // card's own box - instead of the column, which `d-block` stretches to full
  // width. Add a product here once its span percentages have been re-measured
  // against its card art.
  const FIXED_CARD_PRODUCTS = [
    "omlyclo",
    "avtozma",
    "stoboclo",
    "osenvelt",
    "steqeyma",
  ];
  const cardFixedClass = FIXED_CARD_PRODUCTS.includes(category)
    ? ` card-fixed card-fixed--${category}`
    : "";
  const isOmlyclo = category === "omlyclo";
  const claimHeading = (
    <Button
      style={{ color: productColor }}
      className={
        isZymfentra
          ? "theme-button theme-button-text zymfentra-purple fw-medium instructions-heading-2"
          : "theme-button theme-button-text secondary-color fw-medium instructions-heading-2"
      }
    >
      INSTRUCTIONS FOR USE:
    </Button>
  );

  const isPaySign =
    category === "steqeyma" ||
    category === "zymfentra" ||
    category === "stoboclo" ||
    category === "osenvelt"||
    category === "avtozma"||
    category === "omlyclo"||
    category === "adalimumab" ||
    category === "vegzelma";





  useEffect(() => {
    const fetchAndDownloadPDF = async () => {
       if (isFirstRender.current) {
        const downloadFile = searchParams.get("downloadPDF");
        if (downloadFile === "true") {
          await DownloadPDF("root", "Instructions.pdf");
          setTimeout(() => {
            window.close();
          }, 500);
        }
      }
      isFirstRender.current = true;
    };

    fetchAndDownloadPDF();
  }, [searchParams]);

  let spanClass =
    isZymfentra || category === "adalimumab"
      ? "rselection roles-section3"
      : "rselection roles-section2";

  const categoryCardClasses = {
    yuflyma: "spanYuflyma download",
    zymfentra: "spanZymfentra",
    adalimumab: "spanAdalimumab download",
    vegzelma: "spanVegzelma-download",
    steqeyma: "spanSteqeyma",
    osenvelt: "spanOsenvelt download",
    stoboclo: "spanStoboclo download",
    avtozma: "spanAvtozma download",
    omlyclo: "spanOmlyclo download",
  };

  return (
    <>
      <section className={spanClass}>
        {category === "yuflyma" ? (
          <img src={yuflymaLogo} className="bevacizumab" />
        ) : category === "vegzelma" ? (
          <img src={bevacizumab} className="bevacizumab" />
        ) : category === "zymfentra" ? (
          <img src={zymfentraLogo} className="bevacizumab" />
        ) : category === "adalimumab" ? (
          <img src={adalimumabLogo} className="bevacizumab" />
        ) : null}
        <Container>
          <Row>
            <Col>
              <div
                className={`rselection-wrap role-wrap firstCard firstCardDownload${
                  isOmlyclo ? " omlyclo-pdf-card" : ""
                }`}
              >
                <div className="heads-icon">
                  <div className="all-set">
                    <p className="mainText mt1">You’re all set!</p>
                    <p className="mainText mt2">
                      Congratulations! Your enrollment in the Celltrion CARES
                      <sup className="reg">&reg;</sup> Co-pay Assistance Program
                      is complete!
                    </p>
                  </div>
                </div>
                <div className="text-center">
                  <p className="text-center title-saving mainText">
                    Co-pay Savings Card Information
                  </p>
                  <div
                    className={`card-wrapper d-block${cardFixedClass}`}
                  >
                    {category === "yuflyma" ? (
                      <img src={cardyuflyma} alt="card" />
                    ) : category === "vegzelma" ? (
                      <img src={card} alt="card" />
                    ) : category === "zymfentra" ? (
                      <img src={cardzymfentra} alt="card" />
                    ) : category === "adalimumab" ? (
                      <img src={cardadalimumab} alt="card" />
                    ) : category === "steqeyma" ? (
                      <img src={cardsteqeyma} alt="card" />
                    ) : category === "stoboclo" ? (
                      <img src={cardstoboclo} alt="card" />
                    ) : category === "osenvelt" ? (
                      <img src={cardosenvelt} alt="card" />
                    ) : category === "avtozma" ? (
                      <img src={cardavtozma} alt="card" />
                    ) : category === "omlyclo" ? (
                      <img src={cardomlyclo} alt="card" />
                    ) : null}
                    <span className={categoryCardClasses[category] || ""}>
                      {cardID}
                    </span>
                    {/* {category === "zymfentra" && (
                      <>
                        <span className="binZymfentra">{rxBin}</span>
                        <span className="pcnZymfentra">{rxPcn}</span>
                        <span className="groupZymfentra">{rxGroup}</span>
                      </>
                    )} */}
                  </div>
                    <div className="button-holders">
                      {!isOmlyclo && claimHeading}
                    </div>
                </div>
                {isPaySign && (
                 <div className="font-14">
                    <Container
                      style={isOmlyclo ? undefined : { paddingRight: "40px" }}
                    >
                      <div className={isOmlyclo ? "claims-panel" : undefined}>
                      {isOmlyclo && (
                        <div className="button-holders">{claimHeading}</div>
                      )}
                      <p>
                        If you are a doctor's office, print this copay card and
                        make sure you include it in the patient's chart.
                      </p>
                      <p>
                        Once you have received the primary Explanation of
                        Benefits (EOB) from the insurance provider, please
                        follow the steps listed below for submitting
                        claims:{" "}
                      </p>
                      <p>
                        Either the patient or the healthcare provider (HCP)
                        should submit the following documents via fax to
                        877-431-6444.
                      </p>
                      <ul>
                        <li>
                          For the first claim submission for your patient,
                          include the Provider Payment Form found{" "}
                          <a
                            href="/files/Provider_Payment_Form.pdf"
                            target="_blank"
                            rel="noreferrer"
                          >
                            here
                          </a>
                          .
                        </li>
                        <li>
                          Completed claim form (Universal, UB or CMS-1500 Claim
                          Form).
                        </li>
                        <li>
                          Primary Explanation of Benefits (EOB) showing itemized
                          claim from the patient's private insurance company
                          with the cost for each NDC listed separately.
                        </li>
                      </ul>
                      <p>
                        Your office will receive reimbursement of the patient's
                        applicable co-pay or coinsurance as determined by the
                        Program Terms and Conditions.
                      </p>
                      <p>
                        Once all information has been received and validated,
                        please allow 7-10 business days to receive payment. The
                        provider's office will collect patient out-of-pocket
                        responsibility, based on the patient's insurance
                        coverage. The provider is responsible for the collection
                        of the remaining balance from the patient.
                      </p>
                      <p>
                        Please note: You must submit the claim for reimbursement
                        to the Patient Support Program within 180 days of the
                        date listed on the EOB from the patient's primary
                        insurance company.
                      </p>
                      </div>

                      <div>
                        <div className="button-holders">
                          <Button
                            style={{ color: productColor }}
                            className={
                              isZymfentra
                                ? "theme-button theme-button-text zymfentra-purple fw-medium instructions-heading-2"
                                : "theme-button theme-button-text secondary-color fw-medium instructions-heading-2"
                            }
                          >
                            PHARMACY CLAIMS PROCESSING:
                          </Button>
                        </div>
                        <p>
                          When you use this card, you are certifying that you
                          have not submitted and will not submit a claim for
                          reimbursement under any federal, state or other
                          governmental programs for this prescription.
                        </p>
                        <ul>
                          <li>
                            Submit transaction to Paysign using{" "}
                            <strong> BIN #610020</strong>
                          </li>
                          <li>
                            If primary commercial prescription insurance exists,
                            input card information as secondary coverage and
                            transmit using the COB segment of the NCPDP
                            transaction. Applicable discounts will be displayed
                            in the transaction response.
                          </li>
                          <li>
                            Acceptance of this card and your submission of
                            claims for the Co-pay Program are subject to the
                            Celltrion CARES<sup className="reg">&reg;</sup>{" "}
                            Co-pay Assistance Program{" "}
                            <a
                              href="#"
                              onClick={() => setModalShow(true)}
                              style={{
                                color: "#652E6C",
                                textDecoration: "underline",
                              }}
                            >
                              Terms and Conditions
                            </a>
                            .
                          </li>
                          <li>
                            The Patient is not eligible if prescriptions are
                            paid in part or full by any state or federally
                            funded programs, including but not limited to
                            Medicare or Medicaid, Medigap, VA, DOD, TRICARE, or
                            where prohibited by law.
                          </li>
                          <li>
                            The Celltrion CARES<sup className="reg">&reg;</sup>{" "}
                            Co-pay card is not valid for use with any other
                            prescription drug discount or cash cards. Claims
                            submitted utilizing the program are subject to
                            audit or validation.
                          </li>
                          <p>
                            For questions regarding setup, claim transmission,
                            patient eligibility or other issues, call the
                            Celltrion CARES
                            <sup>&reg;</sup> Co-pay Assistance Program at{" "}
                            <span className="fw-medium">877-812-6662</span>, 8 <span style={meridiem}>AM</span>-8 <span style={meridiem}>PM</span> ET, Monday - Friday.
                          </p>
                        </ul>
                      </div>
                    </Container>
                  </div>
                )}

                {!isPaySign && (
                  <div className="font-14">
                    <p className="font-16 fw-medium">
                      PHARMACY CLAIMS PROCESSING:
                    </p>
                    <p>
                      When you use this card, you are certifying that you have
                      not submitted and will not submit a claim for
                      reimbursement under any federal, state or other
                      governmental programs for this prescription.
                    </p>
                    <ul>
                      {(category === "zymfentra" ||
                        category === "steqeyma") && (
                        <>
                          <li>
                            Submit transaction to Paysign using{" "}
                            <strong>BIN #610020</strong>
                          </li>
                          <li>
                            If primary commercial prescription insurance exists,
                            input card information as secondary coverage and
                            transmit using the COB segment of the NCPDP
                            transaction. Applicable discounts will be displayed
                            in the transaction response.
                          </li>
                          <li>
                            Acceptance of this card and your submission of
                            claims for the Co-pay Program are subject to the
                            Celltrion CARES
                            <sup>&reg;</sup> Co-pay Assistance Program Terms
                            and Conditions posted at{" "}
                            <a
                              href="https://www.celltrionconnect.com/terms-of-use/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              celltrionconnect.com/terms-of-use/
                            </a>
                          </li>
                        </>
                      )}
                      {category !== "zymfentra" && (
                        <>
                          <li>Submit transaction to BIN #610524</li>
                          <li>
                            If primary commercial prescription insurance exists,
                            input card information as secondary coverage and
                            transmit using the COB segment of the NCPDP
                            transaction. Applicable discounts will be displayed
                            in the transaction response.
                          </li>
                          <li>
                            Acceptance of this card and your submission of
                            claims for the Co-pay Program are subject to the
                            Celltrion CARES<sup>&reg;</sup> Co-pay Assistance
                            Program Terms and Conditions posted at{" "}
                            <a
                              href="https://www.mckesson.com/mprstnc"
                              target="_blank"
                              rel="noreferrer"
                            >
                              www.mckesson.com/mprstnc
                            </a>
                          </li>
                        </>
                      )}
                      <li>
                        The Patient is not eligible if prescriptions are paid in
                        part or full by any state or federally funded programs,
                        including but not limited to Medicare or Medicaid,
                        Medigap, VA, DOD, TRICARE, or where prohibited by law.
                      </li>
                      <li>
                        The Celltrion CARES<sup>&reg;</sup> Co-pay card is not
                        valid for use with any other prescription drug discount
                        or cash cards. Claims submitted utilizing the program
                        are subject to audit or validation.
                      </li>
                    </ul>

                    <p>
                      For questions regarding setup, claim transmission, patient
                      eligibility or other issues, call the Celltrion CARES
                      <sup>&reg;</sup> Co-pay Program at{" "}
                      <span className="fw-medium">
                        1-877-812-6662
                      </span>
                      , 8 <span style={meridiem}>AM</span>-8 <span style={meridiem}>PM</span> ET, Monday - Friday.
                    </p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          {/* </div> */}
        </Container>
      </section>
    </>
  );
};

export default Pharma;
